const char2num = '0123456789A?BCDEFGHIJK?LMNOPQRSTU?VWXYZ'

/**
 * js implementation of com.modifi.api.shared.utils.CargoUtils
 * @param {string} containerId
 */
export const validateContainerId = (containerId: string): string | any[] | undefined => {
  const cleanContainerId = containerId.replace(/-/, '')
  if (cleanContainerId.length !== 11) {
    return ['container-id.error.has-length', {hasLength: 11}]
  }

  const sum = cleanContainerId
    .substr(0, 10)
    .split('')
    .reduce((result, character, index) => {
      const n = char2num.indexOf(character)
      if (n === -1) {
        return result
      }
      return result + n * 2 ** index
    }, 0)
  const checksum = (sum % 11) % 10
  const isValid = char2num.indexOf(cleanContainerId.substr(-1)) === checksum
  if (!isValid) {
    return ['container-id.error.checksum']
  }
  return undefined
}
